<template>
  <div>
    <span v-if="component.type !== 'checkbox'" class="caption grey--text text--darken-1">{{component.label}}</span>
    <v-select
      v-if="['single-select', 'multi-select'].includes(component.type)"
      clearable
      :multiple="component.type === 'multi-select'"
      :items="component.options || []"
      :value="value"
      @change="updateComponent"
      @click:clear="() => (updateComponent(''))"
      solo
      class="thin-border"
    />
    <v-text-field
      v-else-if="component.type === 'text-field'"
      :value="value"
      @input="updateComponent"
      solo
      class="thin-border"
    />
    <v-text-field
      v-else-if="['numeric-field', 'month-field', 'year-field'].indexOf(component.type) >= 0"
      :value="value"
      @input="updateComponent"
      type="number"
      solo
      class="thin-border"
    />
    <v-checkbox
      v-else-if="component.type === 'checkbox'"
      :label="component.label"
      :input-value="value"
      @change="updateComponent"
    />
    <v-textarea
      v-else-if="component.type === 'text-area'"
      :value="value"
      @input="updateComponent"
      outline
      class="thin-border"
    />
    <DatePicker
      v-else-if="component.type === 'date-picker'"
      :max="new Date().toISOString().substring(0, 10)"
      :value="value"
      @input="updateComponent"
      outline
    />
  </div>
</template>
<script>
import DatePicker from '../../../components/inputs/DatePicker';

export default {
  components:{
    DatePicker
  },
  props: {
    component: { type: Object, default: null },
    value: { default: null },
  },
  methods:{
    updateComponent(val){
      this.$emit("input", val);
    }
  }
}
</script>